package com.eladfinish.bible.contest.extensions

import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

/**
 * Developed by
 * @author Elad Finish
 */

inline fun <reified T : Any> Any.toJson(): String =
    Json.encodeToString(this as T)
